export default __webpack_public_path__ + "static/media/myfull02.dc814d98.png";